import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";

interface ServiceMemberFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
}

export default function ServiceMemberFilters({
  search,
  onSearchChange,
}: ServiceMemberFiltersProps) {
  return (
    <div className="service-members-filters">
      <div className="search-container">
        <div className="search-input-wrapper">
          <SearchIcon className="search-icon-left" fontSize="small" />
          <input
            className="form-input search-input-with-icons"
            placeholder="Search members..."
            value={search}
            onChange={(event) => onSearchChange(event.target.value)}
          />
          {search && (
            <button
              type="button"
              className="search-clear-button"
              onClick={() => onSearchChange("")}
              aria-label="Clear member search"
            >
              <CloseIcon fontSize="small" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
